import * as React from "react";
const IconReflect = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M19.6 16.5H7c-2.8 0-5 2.2-5 5V42c0 2.8 2.2 5 5 5h12.6c2.8 0 5-2.2 5-5V21.5c0-2.8-2.2-5-5-5m3 25.5c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V21.5c0-1.7 1.3-3 3-3h12.6c1.7 0 3 1.3 3 3zM57 16.5H44.4c-2.8 0-5 2.2-5 5V42c0 2.8 2.2 5 5 5H57c2.8 0 5-2.2 5-5V21.5c0-2.8-2.2-5-5-5M60 42c0 1.7-1.3 3-3 3H44.4c-1.7 0-3-1.3-3-3V21.5c0-1.7 1.3-3 3-3H57c1.7 0 3 1.3 3 3zM32 6.4c-.6 0-1 .4-1 1v4.2c0 .6.4 1 1 1s1-.4 1-1V7.4c0-.6-.4-1-1-1M32 21.4c-.6 0-1 .4-1 1v4.2c0 .6.4 1 1 1s1-.4 1-1v-4.2c0-.6-.4-1-1-1M32 36.4c-.6 0-1 .4-1 1v4.2c0 .6.4 1 1 1s1-.4 1-1v-4.2c0-.6-.4-1-1-1M32 51.4c-.6 0-1 .4-1 1v4.2c0 .6.4 1 1 1s1-.4 1-1v-4.2c0-.6-.4-1-1-1" />
  </svg>
);
export default IconReflect;
